export var isUHTraceContentSearch = function isUHTraceContentSearch(message) {
  return message.type === 'TRACE' && message.message.message_template === 'CONTENT_SEARCH';
};
export var isUHTraceAnalyzingState = function isUHTraceAnalyzingState(message) {
  return message.type === 'TRACE' && message.message.message_template === 'ANALYSING_STATE';
};